/**
 * Global Search Types
 * Shared types and configuration for the global search functionality
 */

// Search section configuration
export const SEARCH_SECTIONS = {
  kunden: { id: 'kunden', label: 'Kunden', module: 'crm' },
  eigenvertraege: { id: 'eigenvertraege', label: 'Eigenverträge', module: 'crm' },
  fremdvertraege: { id: 'fremdvertraege', label: 'Fremdverträge', module: 'crm' },
  gesellschaften: { id: 'gesellschaften', label: 'Gesellschaften', module: 'produktanbieter' },
  ansprechpartner: { id: 'ansprechpartner', label: 'Ansprechpartner', module: 'produktanbieter' },
  leads: { id: 'leads', label: 'Leads', module: 'leads' },
  aufgaben: { id: 'aufgaben', label: 'Aufgaben', module: 'aufgaben' },
  vertriebspartner: { id: 'vertriebspartner', label: 'Vertriebspartner', module: 'vertriebspartner' },
  abrechnungen: { id: 'abrechnungen', label: 'Abrechnungen', module: 'buchhaltung' },
  zugaenge: { id: 'zugaenge', label: 'Zugänge', module: 'produktanbieter' },
  vermittlernummern: { id: 'vermittlernummern', label: 'Vermittlernummern', module: 'produktanbieter' },
  rabatte: { id: 'rabatte', label: 'Rabatte', module: 'produktanbieter' },
  downloadcenter: { id: 'downloadcenter', label: 'Downloadcenter', module: 'downloadcenter' },
  buchhaltung: { id: 'buchhaltung', label: 'Buchhaltung', module: 'buchhaltung' },
  elearning: { id: 'elearning', label: 'E-Learning', module: 'elearning' },
  vorlagen: { id: 'vorlagen', label: 'Vorlagen', module: 'buchhaltung' },
  berichte: { id: 'berichte', label: 'Berichte', module: 'berichte' },
  einstellungen: { id: 'einstellungen', label: 'Einstellungen', module: 'einstellungen' },
} as const;

export type SearchSectionId = keyof typeof SEARCH_SECTIONS;

export interface SearchResult {
  id: string;
  type: SearchSectionId;
  title: string;
  subtitle?: string;
  badge?: string;
  data: any;
  relevanceScore?: number; // Added for relevance sorting
}

export interface GlobalSearchFilters {
  enabledSections: Set<SearchSectionId>;
  kundentyp?: 'all' | 'privat' | 'gewerbe';
  leadheldenLead?: 'all' | 'ja' | 'nein';
  partnerId?: string;
  exactMatch?: boolean;
  fuzzyMatch?: boolean; // Enable typo-tolerant matching (e.g., "Müler" finds "Müller")
}

export interface UseGlobalSearchOptions {
  filters: GlobalSearchFilters;
  limit?: number;
}

// Lookup data types for caching
export interface LookupData {
  sparteById: Map<string, string>;
  gesellschaftById: Map<string, string>;
  kundeById: Map<string, { id: string; vorname?: string; zuname?: string; firmenname?: string }>;
}
